import { IndianStates } from "Constants/Arrays";
import { FormDataType } from "../../../DataTypes/Form";

export const registrationFormData: () => FormDataType[] = () => {
  return [
    {
      id: "firstName",
      label: "First Name",
      placeholder: "Enter Frist Name",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "name",
      required: true,
    },
    {
      id: "lastName",
      label: "Last Name",
      placeholder: "Enter Last Name",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "name",
      required: true,
    },
    // {
    //   id: "address",
    //   label: "Address",
    //   placeholder: "Enter Address",
    //   boxType: "input-box",
    //   boxSize: 3,
    //   type: "text",
    //   validatetype: "acceptAll",
    //   required: true,
    // },
    // {
    //   id: "city",
    //   label: "City",
    //   placeholder: "Enter City",
    //   boxType: "input-box",
    //   boxSize: 3,
    //   type: "text",
    //   validatetype: "acceptAll",
    //   required: true,
    // },
    // {
    //   id: "state",
    //   label: "State",
    //   placeholder: "Enter State",
    //   boxType: "single-select-drop",
    //   boxSize: 3,
    //   type: "text",
    //   validatetype: "dropdown",
    //   required: true,
    //   dropArr: IndianStates,
    // },
    // {
    //   id: "postalCode",
    //   label: "Postal Code",
    //   placeholder: "Enter Postal Code",
    //   boxType: "input-box",
    //   boxSize: 3,
    //   type: "number",
    //   validatetype: "acceptAll",
    //   required: true,
    // },
    // {
    //   id: "dob",
    //   label: "Date Of Birth",
    //   placeholder: "Enter Date Of Birth",
    //   boxType: "mui-date",
    //   boxSize: 3,
    //   type: "date",
    //   validatetype: "date",
    //   required: true,
    // },
    
    // {
    //   id: "description",
    //   label: "Description",
    //   placeholder: "Enter Description",
    //   boxType: "input-box",
    //   boxSize: 3,
    //   type: "text",
    //   validatetype: "acceptAll",
    //   required: true,
    //   visible: false
    // },
    {
      id: "password",
      label: "Password",
      placeholder: "Choose Password",
      boxType: "input-box",
      boxSize: 3,
       type: "password",
      validatetype: "password",
      required: true,
      showPassword: false,
      hasPasswordToggle: true,
    },
  ];
};
